var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuProductIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78329 1.6665H6.59996C7.77496 1.6665 8.71663 2.62484 8.71663 3.80067V6.6415C8.71663 7.82484 7.77496 8.77484 6.59996 8.77484H3.78329C2.61663 8.77484 1.66663 7.82484 1.66663 6.6415V3.80067C1.66663 2.62484 2.61663 1.6665 3.78329 1.6665ZM3.78329 11.2246H6.59996C7.77496 11.2246 8.71663 12.1754 8.71663 13.3588V16.1996C8.71663 17.3746 7.77496 18.3329 6.59996 18.3329H3.78329C2.61663 18.3329 1.66663 17.3746 1.66663 16.1996V13.3588C1.66663 12.1754 2.61663 11.2246 3.78329 11.2246ZM16.2167 1.6665H13.4C12.225 1.6665 11.2834 2.62484 11.2834 3.80067V6.6415C11.2834 7.82484 12.225 8.77484 13.4 8.77484H16.2167C17.3834 8.77484 18.3334 7.82484 18.3334 6.6415V3.80067C18.3334 2.62484 17.3834 1.6665 16.2167 1.6665ZM13.4 11.2246H16.2167C17.3834 11.2246 18.3334 12.1754 18.3334 13.3588V16.1996C18.3334 17.3746 17.3834 18.3329 16.2167 18.3329H13.4C12.225 18.3329 11.2834 17.3746 11.2834 16.1996V13.3588C11.2834 12.1754 12.225 11.2246 13.4 11.2246Z",
    fill: "#00609B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuProductIcon);
export default __webpack_public_path__ + "static/media/Menu-ProductIcon.f2f0f4f19342841f9ca7acca25f28ca4.svg";
export { ForwardRef as ReactComponent };